export default __webpack_public_path__ + "static/media/add.4a566026.svg";